import { EventEmitter, Injectable } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ModalService {

  public modalResponse$ = new EventEmitter();

  isOpenModal: boolean = false;

  private config = {
    animated: true,
    keyboard: true,
    backdrop: true,
    ignoreBackdropClick: true,
    class: 'modal-dialog-centered initialState'
  };

  constructor(
    private bsModalService: BsModalService,
    private bsModalRef: BsModalRef
  ) { }

  public showModal(modalComponentContent, data?): Observable<any> {
    const initialState = {
      data: data
    };
    this.bsModalRef = this.bsModalService.show(modalComponentContent, Object.assign({}, this.config, {initialState}));
    return this.modalResponse$;
  }

  public closeModal(status?) {
    this.isOpenModal = false;
    this.bsModalRef.hide();
    this.modalResponse$.emit(status);
  }
}
